namespace advisorop.components.identity {

    class LoginFormController {

        $router;

        pnlMainPanel: advisorop.components.widgets.AdvisoropPanelController;

        public user: domains.identity.ILoginFormModel;

        laddaLoginInProgress = false;

        loginSuccess = false;

        show2FAMethodSelectionScreen: boolean;
        show2FACodeEntryScreen: boolean;

        twofPhones: string[] = [];
        twofEmails: string[] = [];
        phoneSel: number;
        emailSel: number;
        authenticationCodeMethodVerb: string = "sent";

        uiType: string;
        okToPaint: boolean;
        meetingLogin: boolean;
        meetingGuid: string;
        participantGuid: string;
        onLoginResult: any;

        /// Whether this deployment offers Salesforce sign-in. Asked of the server rather than
        /// assumed: one build serves every client, and only some of them have Salesforce.
        ssoEnabled: boolean = false;
        ssoButtonText: string;

        constructor(private identityService: services.IdentityService) {

            this.user = {
                username: "",
                password: "",
                rememberMe: false,
                privateMachine: false,
                returnUrl: localStorage.getItem("returnUrl"),
                token: null,
            }


            this.uiType = "";

            //console.log(this.user);     
        }

        //login method
        sendCode(): void {
            if (this.phoneSel != undefined) {
                this.authenticationCodeMethodVerb = "texted";
                this.user.twofMethod = domains.AuthenticationCodeMethod.PHONE
                this.user.twofAddressIndex = this.phoneSel;
                this.logMeIn(false);
                return;
            } else if (this.emailSel != undefined) {
                this.authenticationCodeMethodVerb = "emailed";
                this.user.twofMethod = domains.AuthenticationCodeMethod.EMAIL
                this.user.twofAddressIndex = this.emailSel;
                this.logMeIn(false);
                return;
            }
            return;
        }

        //login method
        async logMeIn(tokenValidation: boolean = false) {

            let retPromise: any;
            this.user.isMeetingLogin = this.meetingLogin;
            this.user.meetingGuid = this.meetingGuid;
            this.user.participantGuid = this.participantGuid;
            try {
                this.laddaLoginInProgress = true;
                // this.pnlMainPanel.showLoadingPanel();
                localStorage.clear();

                //at the same time this is Login and Token validation
                retPromise = await this.identityService.login(this.user)
                    .then(r => {
                        this.twofPhones = [];
                        this.twofEmails = [];

                        // Reset these variables each time
                        this.user.twofMethod = undefined;
                        this.user.twofAddressIndex = undefined;

                        if (r.retCode == 2 && !tokenValidation) {
                            this.twofEmails = r.twofEmails;
                            this.twofPhones = r.twofPhones;
                            // clear out any selection if it exists
                            this.phoneSel = undefined;
                            this.emailSel = undefined;
                            this.show2FACodeEntryScreen = false;
                            this.show2FAMethodSelectionScreen = true;
                        }
                        if (r.retCode == 3 && !tokenValidation) {
                            this.show2FAMethodSelectionScreen = false;
                            this.show2FACodeEntryScreen = true;
                        }
                        return r.retCode;
                    })
                    .finally(() => {
                        this.laddaLoginInProgress = false;
                    });

                // retPromise == 2 means user will be asked if they want to receive the 2fa code via email or SMS,
                //      and they will need to select an address(email or phone numner) to send
                // retPromise == 3 means user has been sent TwoFactorAuthentication token
                if ((retPromise == 2 || retPromise == 3) && !tokenValidation) {
                    //console.log("2FA workflow...");
                    return retPromise;
                }

                if (this.meetingLogin) {
                    this.onLoginResult({ result: retPromise })
                } else {
                    this.laddaLoginInProgress = true;

                    retPromise = await this.identityService.getUserPromise()
                        .then((response: any) => {
                            if (response.err && response.err.status == 401) {
                                toastr.error("Username or password is not correct please try again");
                                return;
                            }
                        }, err => toastr.warning("Can not fetch userdata from server at this moment!"))
                        .finally(() => {
                            this.laddaLoginInProgress = false;
                            // this.pnlMainPanel.hideLoadingPanel();
                        });

                    // Used once. Left behind, it would send every later sign-in on this browser
                    // back to the same place - for an AI assistant's sign-in, a stale approval page.
                    localStorage.removeItem("returnUrl");

                    if (this.user.returnUrl && this.user.returnUrl.indexOf("/") > 1) {
                        window.location.href = this.user.returnUrl;
                    }
                    else {
                        // remove SAML redirect to advisorop
                        // window.location.href = "/samlidp/initiatessowithadvisorop";
                        window.location.href = "/";
                    }
                }
            } catch (error) {
                toastr.error(error.message);
                return retPromise;
            } finally {
                this.laddaLoginInProgress = false;
            }

            return retPromise;
        };

        onMainPanelReady(ctrl) {
            this.pnlMainPanel = ctrl;
        }


        $onInit(): void {
            //this.show2FAScreen = false;

            this.identityService.getSsoConfig()
                .then((response: any) => {
                    this.ssoEnabled = !!(response.data && response.data.enabled);
                    this.ssoButtonText = response.data ? response.data.buttonText : null;
                }, () => {
                    // A deployment without Salesforce answers this happily; a genuine failure just
                    // means no button, which is the safe way to be wrong.
                    this.ssoEnabled = false;
                });
        }

        /// Hands the browser to the server, which builds the Salesforce URL and redirects. Nothing
        /// about the arrangement passes through here.
        loginViaSalesforce(): void {
            window.location.href = "/api/identity/salesforce-login";
        }

        /// Why a Salesforce sign-in did not finish. The server sends a short code rather than a
        /// message so that nothing here reveals whether an account exists.
        private showSsoError(code: string): void {
            switch (code) {
                case "denied":
                    toastr.warning("Sign-in was not completed.");
                    break;
                case "expired":
                    toastr.warning("That took too long. Please try signing in again.");
                    break;
                case "nolink":
                    toastr.error("That Salesforce account is not linked to a login here. Please contact your administrator.");
                    break;
                default:
                    toastr.error("We could not sign you in. Please try again.");
                    break;
            }
        }

        $routerOnActivate(next, previous) {

            //this.show2FAScreen = false;

            // A failed Salesforce sign-in comes back as a server redirect carrying a reason, so it
            // is read from the address rather than from the component router's params.
            const ssoError = /[?&]ssoerror=([^&]+)/.exec(window.location.search);

            if (ssoError) {
                this.showSsoError(decodeURIComponent(ssoError[1]));
            }

            //case when user enter logout path
            if (next.urlPath == "logout") {
                localStorage.clear();
            }

            if (next != null && next.params != null)
                this.uiType = next.params.uiType;

            // redirect screens less than 800 pixels wide to the mobile site unless desktop uiType is forced
            if (this.uiType != "desktop" && window.screen.availWidth < 800) {
                var href: string = "https://m." + location.host;
                window.location.replace(href);
            }
            else
                this.okToPaint = true;
        }

        backToLoginScreen(): void {
            this.show2FACodeEntryScreen = false;
            this.show2FAMethodSelectionScreen = false;
            // reset entered token
            this.user.token = null;
        }

        emailSelected(): void {
            // deselect any of the phone selections
            this.phoneSel = undefined;
            //console.log("EMAILSEL", this.emailSel);
            //console.log("PHONESEL", this.phoneSel);
        }

        phoneSelected(): void {
            // deselect any of the email selections
            this.emailSel = undefined;
            //console.log("EMAILSEL", this.emailSel);
            //console.log("PHONESEL", this.phoneSel);
        }
    }



    class LoginForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                $router: '<',
                uiType: '<',
                okToPaint: '<',
                meetingLogin: '<',
                meetingGuid: '<',
                participantGuid: '<',
                onLoginResult: '&'
            };
            this.controller = ["identityService", LoginFormController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/login-form.html';
        }

    }
    angular.module(Constants.APP).component("loginForm", new LoginForm());
}